var _defs, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCartBlackFilledIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.4 113.4",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #1d1d1b;\n      }\n\n      .st0, .st1 {\n        stroke: #1d1d1b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 8.5px;\n      }\n\n      .st1 {\n        fill: none;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "108.2 108.9 4.4 108.9 16.4 36.6 95.9 36.6 108.2 108.9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.9,56.7V21.6c0-9.4-7.6-17-17-17h0c-9.4,0-17,7.6-17,17v35.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.4,6.8c-2.5-1.4-5.4-2.3-8.5-2.3h0c-9.4,0-17,7.6-17,17v15"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCartBlackFilledIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cart-black-filled-icon.7340b8c7d5396a2f0ad308339c8d19eb.svg";